import type { EventEvolutionEvent } from "./EventEvolutionTypes";
import { EventRecordsList } from "./EventRecordsList";
import type { ConjunctionRiskConfig } from "../conjunctions/conjunctionUiUtils";
import type { FormatterMap } from "../../helpers/utils";

interface EventRecordsPanelProps {
  activeRecordId: string;
  formatters?: FormatterMap;
  records: EventEvolutionEvent[];
  riskConfig?: ConjunctionRiskConfig;
}

export const EventRecordsPanel = ({
  activeRecordId,
  formatters,
  records,
  riskConfig,
}: EventRecordsPanelProps) => (
  <section className="flex h-full min-h-0 flex-col">
    <div className="mb-3 flex shrink-0 flex-wrap items-center justify-between gap-2">
      <h3 className="text-xs font-semibold uppercase text-slate-500">
        Record Event List
      </h3>
      <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-600 ring-1 ring-slate-200">
        {records.length} records
      </span>
    </div>
    <EventRecordsList
      activeRecordId={activeRecordId}
      formatters={formatters}
      records={records}
      riskConfig={riskConfig}
    />
  </section>
);
